<template>
  <b-card title="Usuarios del sistema Campus Virtual">
    <section class="pb-4">
      <b-row class="match-height">
        <b-col>
          <listaUsuarios />
        </b-col>
      </b-row>
      <hr>
    </section>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'
import listaUsuarios from './components/dashboard/listaUsuarios.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    listaUsuarios,
  },
}
</script>
